import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncPromotions = async(() =>
  import('../containers/promotions/Promotions').then(module => module.default)
);

const AsyncPromotionsPage = async(() =>
  import('../containers/promotions/PromotionsPage').then(module => module.default)
);

const AsyncExchangePromotionsPage = async(() =>
  import('../containers/promotions/ExchangePromotionsPage').then(module => module.default)
);

function RouteHandler({
  match: {
    params: {
      section = 'exchange',
      promoId
    },
  }
}) {
  if (promoId && section === 'casino') {
    return (
      <AsyncPromotionsPage
        id={promoId}
      />
    );
  } else if (promoId && section === 'exchange') {
    return (
      <AsyncExchangePromotionsPage
        id={promoId}
      />
    );
  }

  return (
    <AsyncPromotions
      section={section}
    />
  );
}

RouteHandler.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      section: PropTypes.string.isRequired,
      promoId: PropTypes.string
    })
  }).isRequired
};

export default withRouter(RouteHandler);
